<section class="action-template">
  @if (templatesError) {
    <app-inline-snackbar
      [type]="SnackbarType.ERROR"
      [message]="'transcriber.templatesError' | translate"
      [showCloseButton]="false"
    ></app-inline-snackbar>
  }

  <mat-form-field appearance="outline">
    <mat-label>{{ 'transcriber.selectActionPlanTemplate' | translate }}</mat-label>
    <mat-select
      name="templateType"
      #templateTypeSelect="ngModel"
      required
      [(ngModel)]="selectedTemplateType"
      [compareWith]="compareTemplateTypes"
      (selectionChange)="onTemplateTypeChange()"
    >
      @for (templateType of templateTypes; track templateType.task) {
        <mat-option [value]="templateType">
          {{ templateType.label }}
        </mat-option>
      }
    </mat-select>

    @if (templateTypeSelect.invalid && templateTypeSelect.touched) {
      <mat-error>
        {{ 'transcriber.selectActionPlanTemplateRequired' | translate }}
      </mat-error>
    }
  </mat-form-field>
  <app-upload-document
    #uploadDocument
    [optionalFilesTitle]="'upload.optionalActionPlans'"
    [documentType]="DocumentTypeEnum.TRANSCRIPT"
  ></app-upload-document>

  <button
    mat-flat-button
    [class.disabled]="isCreateActionPlanDisabled"
    [disabled]="isCreateActionPlanDisabled"
    (click)="createActionPlan()"
  >
    {{ 'stepper.createActionPlan' | translate }}
  </button>
</section>

@if (actionPlanFileError) {
  <app-rerun-task (rerun)="createActionPlan()"></app-rerun-task>
} @else if (isLoading) {
  <div class="empty-action-plan">
    <app-waiting [message]="'stepper.creatingActionPlan' | translate"></app-waiting>
    <button mat-stroked-button (click)="previewActionPlan()">
      {{ 'documentEditor.preview' | translate }}
    </button>
  </div>
} @else if (actionPlanFile) {
  <p class="bold">{{ 'transcriber.actionPlanDocument' | translate }}</p>
  <div class="action-plan">
    <p>
    {{ 'transcriber.actionPlanTemporaryDescription' | translate }}
    </p>
    <div class="action-buttons">
      <button mat-stroked-button (click)="previewActionPlan()">
        {{ 'documentEditor.preview' | translate }}
      </button>
    </div>
  </div>
}
